import { render, staticRenderFns } from "./complaints-personal.pug?vue&type=template&id=19e15e95&lang=pug&external"
import script from "./complaints-personal.js?vue&type=script&lang=js&external"
export * from "./complaints-personal.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports